import { connect } from 'react-redux';

import App from './App';

const mapStateToProps = ({ appState: { currentLevel, isGameOver } }) => ({
  currentLevel,
  isGameOver,
});

export default connect(mapStateToProps)(App);
